import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Privacy.module.sass";
import Loader from "../../components/Loader";
import settings from "../../i11/Settings";

import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import { GetPrivacy, SavePrivacy } from "../../Services/lib/brand";
import { policyHTMLValue } from "./htmlTexts";
import JoditEditor from "jodit-react";
import { baseUrl, editorConfig } from "../../components/Editor";

const Policy = () => {
	const [policy, setPolicy] = useState("");
	let uploadFile, isSuccessData, content;

	const {
		tokens: { access_token },
		brand,
		locale,
	} = useUser();
	const [{ isLoading: initLoading }, getPrivacy] = UseApi({
		service: GetPrivacy,
	});
	const [{ isLoading: draftLoading }, saveDraft] = UseApi({
		service: SavePrivacy,
	});
	const [{ isLoading: publishLoading }, publish] = UseApi({
		service: SavePrivacy,
	});

	const startPolicy = async () => {
		const res = await getPrivacy("draftPolicy");
		if (res) {
			// const _state = htmlToEditorState(res.draftPolicy);
			setPolicy(res.draftPolicy);
		}
		// else setPolicy(htmlToEditorState(""));
	};

	const saveDraft_ = async () => {
		// const html = stateToHtml(policy);
		if (content) setPolicy(content);
		const res = await saveDraft({
			draftPolicy: content || policy,
		});

		if (res) {
			ToastEmitter({
				type: "success",
				msg: "Saved a document by draft successfull.",
			});
		}
	};

	const replaceWithTemplate = () => {
		setPolicy(policyHTMLValue);
	};

	const publish_ = async () => {
		// const html = stateToHtml(policy);

		if (content) setPolicy(content);
		const res = await publish({
			publishPolicy: content || policy,
		});
		if (res) {
			ToastEmitter({
				type: "success",
				msg: "Published by successfull.",
			});
		}
	};

	const config = {
		...editorConfig,
		uploader: {
			imagesExtensions: ["jpg", "png", "jpeg", "gif"],
			insertImageAsBase64URI: false,
			url: `${baseUrl}/v1/image?miniSize=NO&whereFolder=BRANDS`,
			headers: {
				// "Content-Type": "multipart/form-data; boundary=*", //boundary=----WebKitFormBoundary8AXvPJxYK4RnTe00
				Authorization: `Bearer ${access_token}`,
				"x-brand": brand?._id,
				Accept: "*/*",
			},
			method: "POST",
			format: "file",

			processFileName: (key, file, name) => {
				uploadFile = file;
				return [key, file, name];
			},

			buildData: () => {
				const formData = new FormData();
				formData.append("image", uploadFile);
				return formData;
			},
			prepareData: function (formdata) {
				formdata.append("image", uploadFile);
			},
			isSuccess: function (resp, data) {
				isSuccessData = resp;
				return resp?.core_image_url;
			},
			getMessage: function (resp, data) {
				return resp.msg;
			},
			defaultHandlerSuccess: function (resp, data) {
				if (isSuccessData?.success === false) return;
				if (isSuccessData)
					this.s.insertImage(isSuccessData?.core_image_url);
			},

			error: function (e) {
				this.message.message(e.getMessage(), "error", 4000);
			},
		},
	};
	useEffect(() => {
		startPolicy();
	}, []);
	return (
		<div>
			<div>
				{/* <Editor
					state={policy}
					onChange={setPolicy}
					classEditor={styles.editor}
					label={settings[locale].privacy_policy}
					loading={initLoading}
				/> */}

				<div className={styles.label}>
					{settings[locale].privacy_policy} &nbsp;
					{initLoading && <Loader className={styles.loader} />}
				</div>

				<div className={styles.rel}>
					<JoditEditor
						value={policy}
						config={config}
						onChange={(val) => (content = val)}
					/>
				</div>
				<div className={styles.rowF}>
					<button
						className={cn("button-stroke", styles.button)}
						onClick={replaceWithTemplate}
					>
						{settings[locale].replace_with_template}
					</button>
					<div className={styles.row}>
						<button
							className={cn("button-stroke", styles.button)}
							onClick={saveDraft_}
							disabled={draftLoading}
						>
							{draftLoading && <Loader />}
							{settings[locale].save_draft}
						</button>
						<button
							className={cn("button", styles.button)}
							onClick={publish_}
							disabled={publishLoading}
						>
							{publishLoading && <Loader white />}
							{settings[locale].publish}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Policy;
